module.exports = __webpack_public_path__ + "static/the-iliad-872969864e72ea01117cc12a3e561d15.jpg";